export enum AuthGrantType {
    ClientCredentials = 'client_credentials',
    Password = 'password',
    RefreshToken = 'refresh_token',
}
